import RedirectNotification from '@/components/RedirectNotification';
import SignInCard from '@/components/SignInCard';
import { rootRoute } from '@/modules/core/root/route';
import { createRoute, Outlet, redirect } from '@tanstack/react-router';
import * as z from 'zod';

// * This is a pathless route
export const authenticationRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'authentication',
  component: AuthenticationLayout,
  validateSearch: z.object({
    email: z.string().email().optional(),
    redirect: z.string().optional(),
  }),
  beforeLoad: async ({ context }) => {
    await context.auth.checkAuth();
    if (context.auth.isAuthenticated()) {
      throw redirect({
        to: '/charge-center',
        replace: true,
      });
    }
  },
});

// ! Reminder to redo this after the migration is complete
function AuthenticationLayout() {
  const { email } = authenticationRoute.useSearch();
  const redirected = !!email;
  return (
    <>
      {redirected ? <RedirectNotification /> : null}
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <SignInCard>
          <Outlet />
        </SignInCard>
      </div>
    </>
  );
}
